// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import {parse} from 'date-fns';

import {Block, FormField} from './../LayoutComponents';

type DateRangeSelectProps = {
	getLabel: (key: string) => string;
}
export default ({getLabel}: DateRangeSelectProps) => {
	const {getValues, watch} = useFormContext();

	const now = new Date();
	const tenYears = new Date(now.getFullYear() + 10, 11, 31);

	const nameFrom = 'quoteRequest.arrivalTime';
	const nameTo = 'quoteRequest.departureTime';

	const {[nameFrom]: valueFrom, [nameTo]: valueTo} = getValues();
	const parseDateString = (dateString: string|undefined) => dateString
		? parse(dateString, 'dd.MM.yyyy', new Date())
		: undefined;

	watch(nameFrom);
	watch(nameTo);

	return (
		<Block>
			<Block half>
				<FormField
					type="DateInput"
					name={nameFrom}
					label={getLabel('quoteRequest.arrivalTime')}
					required
					minDate={now}
					maxDate={parseDateString(valueTo) || tenYears}
				/>
			</Block>
			<Block half>
				<FormField
					type="DateInput"
					name={nameTo}
					label={getLabel('quoteRequest.departureTime')}
					required
					minDate={parseDateString(valueFrom) || now}
					maxDate = {tenYears}
				/>
			</Block>
		</Block>
	);
}
